import React from 'react';
import BreadcrumbOne from '../../common/breadcrumb/BreadcrumbOne';
import Layout from '../../common/Layout';
import SEO from '../../common/SEO';
import { CoursesProvider } from '../../context/courses_context';
import { FilterProvider } from '../../context/filter_context';
import PosttDataaPte from './PosttDataaPte.json'
import PostOneePte from './PostOneePte';



const PteInnerr = () => {
    return (
        <>
            <SEO title="PTE Inner" />
            <Layout>
                <BreadcrumbOne
                    // title="Study Abroad eBooks"
                    rootUrl="/"
                    parentUrl="Home"
                    currentUrl="Pearson Test of English (PTE) Exam"
                />
                <CoursesProvider>
                    <FilterProvider>
                        <div className="edu-course-area  bg-color-white"style={{marginBottom:"100px"}}>
                            <div className="container">
                                <div className="row g-5">
                                    
                                    
                                    <div className="edu-elements-area bg-color-white">
                                        <div className="container">
                                            <div className="row g-5">
                                                <div className="col-lg-12">
                                                    <div className="row g-5">
                                                        {
                                                            PosttDataaPte.slice(0, 12).map((item) => (
                                                                <div className="col-lg-4 col-md-6 col-12" key={item.id}>
                                                                    <PostOneePte data={item} />
                                                                </div>
                                                            ))
                                                        }
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* <FaqIELTS /> */}

                                 

                                </div>
                            </div>
                        </div>
                    </FilterProvider>
                </CoursesProvider>

                <div >

                </div>
            </Layout>
        </>
    )
}

export default PteInnerr;